import tailwindBaseConfig from '../base/tailwind.config';

export default {
    ...tailwindBaseConfig, // spread the existing config to keep its settings
    theme: {
        ...tailwindBaseConfig?.theme, // spread the existing theme to keep its settings
        extend: {
            ...tailwindBaseConfig?.theme?.extend,
            borderWidth: {
                '3': '3px',
            },
            boxShadow: {
                ...tailwindBaseConfig?.theme?.boxShadow,
                md: '0px 2px 4px -1px rgba(0, 0, 0, 0.08)',
                'scrolled-top':
                    '0px -4px 12px 0px rgba(24, 39, 75, 0.08), 0px -4px 6px 0px rgba(24, 39, 75, 0.02)',
            },
            colors: {
                current: 'currentColor',
            },
            outlineOffset: {
                3: '3px',
            },
            screens: {
                ...tailwindBaseConfig?.theme?.screens,
                'max-lg': { max: '1023px' },
                'max-xl': { max: '1439px' },
            },
        },
    },
};
